export default __webpack_public_path__ + "static/media/bg_9.ce9ccf23.jpg";